export const siteMetadata = {
  title: "CS Development",
  siteName: "CS Development",
  author: "Cory Smith",
  baseUrl: "https://coryevansmith.com",
  description:
    "Cory Smith is a full stack developer building responsive web applications, APIs, and user-focused software solutions.",
  image: "/logo.png",
};

export const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/coryevansmith/",
  },
  {
    label: "GitHub",
    href: "https://github.com/coryevansmith",
  },
  {
    label: "Email",
    href: "mailto:coryevansmith@gmail.com",
  },
];

export const services = [
  "Full Stack Development",
  "Web Applications",
  "API Development",
  "Responsive Design",
  "System Integration",
];

export const contactDetails = {
  email: "coryevansmith@gmail.com",
  phone: "682-557-6391",
  location: "Arlington, Texas",
};
